import { render, staticRenderFns } from "./spm-genera.vue?vue&type=template&id=21672640&scoped=true"
import script from "./spm-genera.vue?vue&type=script&lang=js"
export * from "./spm-genera.vue?vue&type=script&lang=js"
import style0 from "./spm-genera.vue?vue&type=style&index=0&id=21672640&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21672640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21672640')) {
      api.createRecord('21672640', component.options)
    } else {
      api.reload('21672640', component.options)
    }
    module.hot.accept("./spm-genera.vue?vue&type=template&id=21672640&scoped=true", function () {
      api.rerender('21672640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/spm/spm-genera/spm-genera.vue"
export default component.exports